/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginRequest } from '../models/LoginRequest';
import type { LoginResponse } from '../models/LoginResponse';
import type { LogoutRequest } from '../models/LogoutRequest';
import type { MessageResponse } from '../models/MessageResponse';
import type { PasswordChangeRequest } from '../models/PasswordChangeRequest';
import type { PasswordResetConfirmRequest } from '../models/PasswordResetConfirmRequest';
import type { PasswordResetRequest } from '../models/PasswordResetRequest';
import type { RefreshTokenRequest } from '../models/RefreshTokenRequest';
import type { RefreshTokenResponse } from '../models/RefreshTokenResponse';
import type { TokenValidationRequest } from '../models/TokenValidationRequest';
import type { TokenValidationResponse } from '../models/TokenValidationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Login
     * 사용자 로그인
     *
     * 이메일과 비밀번호로 사용자 인증을 수행하고 JWT 토큰을 발급합니다.
     * @returns LoginResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsLogin({
        requestBody,
    }: {
        requestBody: LoginRequest,
    }): CancelablePromise<LoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Logout
     * 사용자 로그아웃
     *
     * 현재 세션을 종료하고 토큰을 무효화합니다.
     * @returns MessageResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsLogout({
        requestBody,
    }: {
        requestBody?: LogoutRequest,
    }): CancelablePromise<MessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/logout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Change Password
     * 비밀번호 변경
     *
     * 현재 비밀번호를 확인하고 새로운 비밀번호로 변경합니다.
     * @returns MessageResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsChangePassword({
        requestBody,
    }: {
        requestBody: PasswordChangeRequest,
    }): CancelablePromise<MessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Password Reset Request
     * 비밀번호 재설정 요청
     *
     * 이메일로 비밀번호 재설정 링크를 전송합니다.
     * @returns MessageResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsPasswordResetRequest({
        requestBody,
    }: {
        requestBody: PasswordResetRequest,
    }): CancelablePromise<MessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Password Reset Confirm
     * 비밀번호 재설정 확인
     *
     * 재설정 토큰을 사용하여 새로운 비밀번호로 변경합니다.
     * @returns MessageResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsPasswordResetConfirm({
        requestBody,
    }: {
        requestBody: PasswordResetConfirmRequest,
    }): CancelablePromise<MessageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/password/reset/confirm',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Refresh Token View
     * 액세스 토큰 갱신
     *
     * 리프레시 토큰을 사용하여 새로운 액세스 토큰을 발급받습니다.
     * @returns RefreshTokenResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsRefreshTokenView({
        requestBody,
    }: {
        requestBody: RefreshTokenRequest,
    }): CancelablePromise<RefreshTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/token/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate Token
     * 토큰 유효성 검사
     *
     * JWT 토큰의 유효성을 검증합니다.
     * @returns TokenValidationResponse OK
     * @throws ApiError
     */
    public static appsAuthenticationViewsValidateToken({
        requestBody,
    }: {
        requestBody: TokenValidationRequest,
    }): CancelablePromise<TokenValidationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/token/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
}
